<template>
  <banner v-if="(showBanners && slides.length>0)" :slides="slides" :key="mfID" :startingSlide="slideStartsAt">
    <template v-if="isScienceDay" v-slot:title="{ title: { title: { imageAltText } } }">
      <section class="data-container">
        <div class="flex-container">
          <div class="logo-container">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/science-day-banner%2FLogo.png?alt=media&token=d103f425-a89f-4809-92e8-11e7b3bfecc9"
                 class="logo-container_img"
                 :alt="imageAltText"/>
          </div>
          <div class="line-container"></div>
          <div class="text-container">
            <h2 class="title is-uppercase text-header">WELCOME ALL TO DISTRICT SCIENCE DAY!</h2>
            <p class="description-container">Explore and engage on projects from Ohio's bright young minds who go above and beyond through their scientific research. Qualifying projects advance to
              compete for nearly $400k in scholarships!</p>
            <button class="button is-primary button-text" @click="$router.push({ name: 'exploreFair', params: {fairSlug:  'state-science-day' }})">Explore The State Science Day Projects<span class="ml-2"><i class="fa-solid fa-arrow-right-long"></i></span></button>
          </div>
        </div>
      </section>
    </template>
    <template v-else-if="isBuckeye" v-slot:title="{ title: { title: { imageAltText } } }">
      <section class="data-container-buckeye">
        <div class="is-flex.buckeye">
          <div class="logo-container-buckeye">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FBuckeye%2F2023%20Logo%20Sponsor%201.png?alt=media&token=b1f6aedd-5a66-4993-bd5a-02f33b89f550"
                 class="logo-container_img"
                 :alt="imageAltText"/>
          </div>
          <div class="text-container-buckeye">
            <div class="banner-desc-buckeye">
              <p>Explore exemplary projects from students across Ohio
              <br>Winning Projects advance to Regeneron ISEF 2023</p>
            </div>
          </div>
        </div>
      </section>
    </template>
    <template v-else-if="isStateScienceDay" v-slot:title="{ title: { title: { imageAltText } } }">
      <section class="data-container-statescienceday">
        <div class="is-flex is-flex-direction-column">
          <div class="logo-container-statescienceday">
            <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/state-science-day-banner%2Fimage%2031.png?alt=media&token=addb5cbc-3098-40d6-b291-f680cf2a72de"
                 class="logo-container_img"
                 :alt="imageAltText"/>
          </div>
          <div class="text-container-statescienceday">
            <h2 class="title is-uppercase text-header title-statescienceday">WELCOME ALL TO STATE SCIENCE DAY!</h2>
            <p class="description-container">Explore and engage on projects from Ohio's bright young minds who go above and beyond through their scientific research. Qualifying projects advance to
                compete for nearly $400k in scholarships!</p>
          </div>
        </div>
        <div class="student-image-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/state-science-day-banner%2FFrame.png?alt=media&token=68fb5969-4dee-4488-a1e4-2acdd9fc7aab"
               :alt="imageAltText"/>
        </div>
      </section>
    </template>
  </banner>
</template>

<script>
import vmfBanner from './vmfBanner'
import Banner from './Banner'

import breakpoints from '@/libs/breakpoints'
import auth from '@/mixins/auth'
import utmTracking from '@/mixins/utm-tracking'
import categorySets from '@/mixins/category-set'

export default {
  props: ['isOasFairs'],
  mixins: [auth, vmfBanner, utmTracking, categorySets],
  components: {
    Banner
  },
  data: function () {
    return {
      category: '',
      categoryID: 0,
      slides: [],
      showBanners: false,
      categoryBanners: [],
      showLearnModal: false,
      startingSlide: 1,
      singleStartingSlide: 1,
      mfID: 0,
      image: ''
    }
  },
  computed: {
    slideStartsAt: function () {
      return this.startingSlide
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    currentFair: function () {
      return this.$store.getters.currentFair(this.$store.getters.currentPage)
    },
    isScienceDay: function () {
      return this.currentFair.abbreviation === 'DSD'
    },
    isStateScienceDay: function () {
      return this.currentFair.abbreviation === 'SSD'
    },
    isBuckeye: function () {
      return this.currentFair.abbreviation === 'BSEF'
    },
    isCategoryBanner: function () {
      return this.singleSlide.filter(slide => (slide.category === this.$route.params.category)).length === 1
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    currentExplorePage: function () {
      return this.$store.getters.currentExplorePage
    },
    slidesByCategory: function () {
      return this.currentExplorePage ? this.currentExplorePage : this.subEventParam()
    },
    banners: function () {
      return this.getCategorySetsForFairExplorePage ?? []
    }
  },
  watch: {
    $route () {
      this.getSlides()
    },
    banners: function () {
      this.getSlides()
    }
  },
  mounted () {
    this.getSlides()
  },
  methods: {
    subEventParam: function () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return this.$route.path.substring(1)
    },
    reset: function () {
      this.showBanners = false
      this.slides = []
    },
    getSlides: async function () {
      this.reset()
      await this.$store.dispatch('getCategorySetsForFairExplorePage', this.$store.getters.currentPage)
      await this.getCategoryObj()
      const catSets = this.banners
      const catBtns = await this.getBannerButtonsForCategoryPage(this.appName, this.categoryID)
      let btnCheck = false
      for (let i = 0; i < catSets.length; i++) {
        // Initialize JSON
        const emp = {}
        emp.content = {}
        emp.content.link = {}
        emp.content.button = {}

        emp.id = catSets[i].id
        emp.title = {
          title: catSets[i].title,
          image: catSets[i].image,
          imageAltText: catSets[i].imageAltText
        }
        emp.description = catSets[i].description
        emp.background = {
          image: catSets[i].background_image
        }
        for (let j = 0; j < catBtns.length; j++) {
          if (catSets[i].id === parseInt(catBtns[j].banner_id)) {
            if (!btnCheck) {
              emp.content.link.show = true
              emp.content.link.text = catBtns[j].text
              emp.content.link.url = catBtns[j].link
              emp.content.link.paramName = catBtns[j].option_name
              emp.content.link.paramValue = catBtns[j].option_value
              btnCheck = true
            } else {
              emp.content.button.show = true
              emp.content.button.text = catBtns[j].text
              emp.content.button.url = catBtns[j].link
              emp.content.button.paramName = catBtns[j].option_name
              emp.content.button.paramValue = catBtns[j].option_value
              btnCheck = false
            }
          }
        }
        btnCheck = false
        if (!this.slides.some(slide => slide.id === emp.id)) {
          this.slides.push(emp)
        }
      }
    },
    getCategoryObj: async function () {
      if (this.$route.params.category && this.$route.params.category.length > 0) {
        this.category = this.$route.params.category
      } else {
        this.category = this.$route.query.category
      }
      if (!this.category) {
        this.category = this.subEventParam()
      }

      try {
        this.categoryObj = await this.getShowBannerForCategoryFlag(this.category)
        if (this.categoryObj !== null) {
          this.categoryID = this.categoryObj.id
          this.showBanners = this.categoryObj.showBanner
        }
        if (this.$route.path === '/home' || this.$route.path === '/viewAll' || this.isOasFairs) {
          this.showBanners = true
        } else {
          this.showBanners = false
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 550px) {
    flex-direction: column;
  }
}
.bg-bsef {
  background: rgba(14,55,99,.8);
  padding: 0 25px;
}

.banner-text {
  font-size: 1.8em;
  font-weight: 600;
  padding: 10px 0;
}

.banner-desc {
  font-size: 1.05em;
}
.banner-desc-buckeye {
  font-size: 1.05em;
  text-align: center;
}

::v-deep .slide29 {
  background-position: center;
  .text {
    display: none;
  }
}
.data-container {
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: -8rem;
  @media (max-width: 550px) {
    margin: -2rem;
  }
}
.data-container-buckeye {
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: -8rem;
@media (max-width: 1024px) {
  margin-top: 0rem;
}
@media (max-width: 450px) {
  margin-left: -1.4rem;
}
}

.logo-container {
  width: 17rem;
  @media (max-width: 1024px) {
    width: 15rem;
  }
  @media (max-width: 820px) {
    width: 14rem;
  }
  @media (max-width: 680px) {
    width: 10rem;
  }
  @media (max-width: 550px) {
    width: 8rem;
  }
}
.logo-container-buckeye {
  height: 17rem;
  width: 34rem;
  margin: auto;
  @media (max-width: 1024px) {
    height: 17rem;
    width: 34rem;
  }
  @media (max-width: 820px) {
    height: 17rem;
    width: 30rem;
  }
  @media (max-width: 550px) {
    height: 17rem;
    width: 25rem;
    margin-left: 10.8rem;
  }
  @media (max-width: 450px) {
    height: 17rem;
    width: 20rem;
    margin-right: 12.1rem;
  }
}
.is-flex .buckeye {
  flex-direction: column;
}
.line-container {
  margin-left: 2rem;
  width: 6px;
  background: #0956a3;
  height: 18rem;
  @media (max-width: 1024px) {
    height: 15rem;
    margin-left: 1rem;
    margin-right: 0.5rem;
  }
  @media (max-width: 820px) {
    width: 5px;
  }
  @media (max-width: 680px) {
    width: 5px;
    height: 10rem;
  }
  @media (max-width: 550px) {
    display: none;
  }
}
.text-container {
  width: 35rem;
  margin-left: 2rem;
  @media (max-width: 1024px) {
    width: 25rem;
    margin-left: 1rem;
  }
  @media (max-width: 820px) {
    width: 20rem;
    margin-left: 1rem;
  }
  @media (max-width: 400px) {
    width: 18rem;
  }
}
.text-container-statescienceday {
    margin-top: 14px;
    height: 50px;
    width: 32rem;
    @media only screen and (max-width: 1024px) {
        width: 23rem;
    }
    @media only screen and (max-width: 414px) {
        width: 20rem;
    }
}
.title-statescienceday {
    @media only screen and (max-width: 1024px) {
        padding-bottom: 1rem;
    }
}
.data-container-statescienceday {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100vw;
    margin-top: 36px;
    height: 390px;
    margin-left: -4rem;
    @media only screen and (max-width: 550px) {
        margin-left: 0;
    }
}
.student-image-container {
    width: 50rem;
    margin-right: 48px;
    @media only screen and (max-width: 1440px) {
        width: 40rem;
        min-width: 40rem;
        margin-top: 48px;
        margin-right: 96px;
    }
    @media only screen and (max-width: 1200px) {
        width: 35rem;
        min-width: 35rem;
        margin-top: 88px;
        margin-right: 96px;
    }
    @media only screen and (max-width: 1024px) {
        width: 30rem;
        min-width: 30rem;
        margin-top: 136px;
        margin-right: 96px;
    }
    @media only screen and (max-width: 820px) {
        display: none;
    }
}
.logo-container-statescienceday {
    margin-top: 36px;
}
.text-container-buckeye {
  height: 25px;
  width: 31rem;
  margin: auto;
  @media (max-width: 1024px) {
    height: 25px;
    width: 31rem;
    margin: auto;
  }
  @media (max-width: 820px) {
    height: 25px;
    width: 31rem;
    margin: auto;
  }
  @media (max-width: 550px) {
    height: 25px;
    width: 25rem;
    margin-left: 11rem;
  }
  @media (max-width: 450px) {
    height: 25px;
    width: 15rem;
    margin-left: 13.4rem;
    margin-top: -6rem;
  }
}
.text-header {
  color: #005bab;
  font-weight: 900;
  font-size: 2.6rem;
  margin-bottom: 0.75rem;
  @media (max-width: 1024px) {
    font-size: 2.2rem;
    margin-bottom: 0.5rem;
  }
  @media (max-width: 820px) {
    font-size: 1.8rem;
  }
  @media (max-width: 680px) {
    font-size: 1.5rem;
  }
}
.description-container {
  color: #090a0a;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.5rem;
  @media (max-width: 1024px) {
    font-size: 1rem;
    line-height: 1.2rem;
  }
  @media (max-width: 820px) {
    font-size: 1rem;
  }
}
.button-text {
  font-weight: 600;
  margin-top: 0.75rem;
  height: 3rem;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  @media (max-width: 820px) {
    height: 2.5rem;
    padding: 1rem;
    font-size: 0.8rem;
  }
}

</style>
